import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ad8a330e")

_pushScopeId("data-v-ad8a330e")
const _hoisted_1 = { class: "password-reset-complete" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "complete-icon" }, [
  /*#__PURE__*/_createVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "64",
    height: "64",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#a3b7ff",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [
    /*#__PURE__*/_createVNode("path", { d: "M22 11.08V12a10 10 0 1 1-5.93-9.14" }),
    /*#__PURE__*/_createVNode("polyline", { points: "22 4 12 14.01 9 11.01" })
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("h1", { class: "title" }, "パスワードの変更が完了しました", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "description" }, "アプリに戻り、新しいパスワードでログインしてください。", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4
  ]))
})